/* ==========================================================================
   Loadout — scroll system

   One passive scroll listener, one rAF frame, one IntersectionObserver.
   Every effect writes only transform/opacity (or a CSS custom property that
   feeds a transform), so nothing here triggers layout. Bails out entirely
   when the visitor has asked for reduced motion.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal on enter (works alongside the base .vs-rv system) ---- */
  var revealTargets = document.querySelectorAll('.vs-rv');
  if (revealTargets.length) {
    if (reduce || !('IntersectionObserver' in window)) {
      for (var r = 0; r < revealTargets.length; r++) revealTargets[r].classList.add('vs-in');
    } else {
      var revealIO = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.classList.add('vs-in');
            revealIO.unobserve(entries[i].target);
          }
        }
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
      for (var j = 0; j < revealTargets.length; j++) revealIO.observe(revealTargets[j]);
    }
  }

  /* ---------- sticky buy bar ----------------------------------------------
     Deliberately set up BEFORE the reduced-motion bail-out: it is a buying
     control, not decoration, so it has to appear for everyone. It only
     toggles a class, and the reduced-motion CSS drops the slide transition. */
  var buybar = document.querySelector('.ld-buybar');
  var buyAnchor = document.getElementById('vsPdpAddBtn');
  if (buybar && buyAnchor) {
    var bbTicking = false;
    function bbFrame() {
      bbTicking = false;
      var rect = buyAnchor.getBoundingClientRect();
      /* show once the real button has scrolled off the top of the viewport */
      if (rect.bottom < 0) buybar.classList.add('ld-on');
      else buybar.classList.remove('ld-on');
    }
    function bbScroll() {
      if (bbTicking) return;
      bbTicking = true;
      if (window.requestAnimationFrame) window.requestAnimationFrame(bbFrame);
      else setTimeout(bbFrame, 60);
    }
    window.addEventListener('scroll', bbScroll, { passive: true });
    window.addEventListener('resize', bbScroll, { passive: true });
    bbFrame();
  }

  if (reduce) return;

  /* ---------- shared frame ------------------------------------------------ */
  var bar = document.querySelector('.ld-progress__bar');
  var parallax = Array.prototype.slice.call(document.querySelectorAll('[data-ld-parallax]'));
  var ticking = false;
  var vh = window.innerHeight || 1;

  function frame() {
    ticking = false;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;

    if (bar) {
      var doc = document.documentElement;
      var max = (doc.scrollHeight - doc.clientHeight) || 1;
      var p = y / max;
      if (p < 0) p = 0; else if (p > 1) p = 1;
      bar.style.transform = 'scaleX(' + p + ')';
    }

    for (var i = 0; i < parallax.length; i++) {
      var el = parallax[i];
      var rect = el.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > vh + 200) continue;
      var speed = parseFloat(el.getAttribute('data-ld-parallax')) || 0.12;
      /* progress of this element through the viewport, -1 .. 1 */
      var mid = rect.top + rect.height / 2;
      var prog = (mid - vh / 2) / (vh / 2 + rect.height / 2);
      el.style.setProperty('--ld-y', (prog * speed * 100).toFixed(2) + 'px');
    }
  }

  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(frame); }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { vh = window.innerHeight || 1; onScroll(); }, { passive: true });
  frame();

  /* ---------- pinned step sequence ---------------------------------------- */
  var stepRoots = document.querySelectorAll('[data-ld-steps]');
  for (var s = 0; s < stepRoots.length; s++) {
    (function (root) {
      var steps = root.querySelectorAll('.ld-step');
      var slides = root.querySelectorAll('.ld-steps__slide');
      if (!steps.length) return;

      function activate(idx) {
        for (var k = 0; k < steps.length; k++) steps[k].classList.toggle('ld-on', k === idx);
        for (var m = 0; m < slides.length; m++) slides[m].classList.toggle('ld-on', m === idx);
      }
      activate(0);

      if (!('IntersectionObserver' in window)) { for (var n = 0; n < steps.length; n++) steps[n].classList.add('ld-on'); return; }

      var stepIO = new IntersectionObserver(function (entries) {
        for (var e = 0; e < entries.length; e++) {
          if (entries[e].isIntersecting) {
            activate(parseInt(entries[e].target.getAttribute('data-ld-index'), 10) || 0);
          }
        }
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });

      for (var q = 0; q < steps.length; q++) stepIO.observe(steps[q]);
    })(stepRoots[s]);
  }
})();
